var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 345,
    viewBox: "0 0 361 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.091 295.714V328.571H32.8182C14.7682 328.571 0 313.786 0 295.714V32.8571C0 14.7857 14.7682 0 32.8182 0H328.182C346.232 0 361 14.7857 361 32.8571V165.929L357.718 162.643C349.514 154.429 339.668 149.5 328.182 149.5V65.7143H32.8182V295.714H164.091ZM334.745 185.643L356.077 207C359.359 210.286 359.359 216.857 356.077 220.143L339.668 236.571L305.209 202.071L321.618 185.643C323.259 184 324.9 182.357 328.182 182.357C331.464 182.357 333.105 184 334.745 185.643M329.823 244.786L231.368 345H196.909V310.5L297.005 210.286L329.823 244.786V244.786Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyActive);
export default __webpack_public_path__ + "static/media/applyActive.16b0d24d9211eaf2fc3ddaa211635401.svg";
export { ForwardRef as ReactComponent };